import SkeletonTable from "@/components/SkeletonTable";
import { getListSertifikatTteSumber } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

export default function SertifikatCbtPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listSertifikatTteSumber", selectedTahun?.value],
    queryFn: () => getListSertifikatTteSumber(selectedTahun?.value),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
